import { DateTime } from 'luxon';

import { useLocalStorageJSON } from 'common/hooks';

export type InsightVersion = 'v1' | 'v2';

export const useInsightViewSwitch = () => {
  const [insightView, setInsightVersion] = useLocalStorageJSON<{ version: InsightVersion; expiration?: Date }>(
    'insights',
    {
      version: 'v2',
    },
  );

  return {
    showInsightV1:
      insightView.version === 'v1' && insightView.expiration && new Date(insightView.expiration) > new Date(),
    setInsightV1: () =>
      setInsightVersion({
        version: 'v1',
        expiration: DateTime.now().plus({ hours: 48 }).toJSDate(),
      }),
    setInsightV2: () => setInsightVersion({ version: 'v1' }),
  };
};

export default useInsightViewSwitch;
